import { createStructuredSelector } from 'reselect'

import {
  ANSWER_LIST,
  ANSWER_LIST_SUCCESS, 
  ANSWER_LIST_ERROR,
  ANSWER_PAGE_SET,
  ANSWER_SEARCH_SET,
  ANSWER_SEARCH_CHANGE,
  ANSWER_SEARCH_ASSESSMENT_LIST,
  ANSWER_SEARCH_ASSESSMENT_LIST_SUCCESS,
  ANSWER_SEARCH_ASSESSMENT_LIST_ERROR, 
  ANSWER_ADD_SET,
  ANSWER_ADD_MODAL_SET,
  ANSWER_ADD,
  ANSWER_ADD_SUCCESS,
  ANSWER_ADD_ERROR,
  ANSWER_ADD_CHANGE,
  ANSWER_DETAIL,
  ANSWER_DETAIL_SUCCESS,
  ANSWER_DETAIL_ERROR,
  ANSWER_VIEW_MODAL_SET,
  ANSWER_EDIT_CHANGE,
  ANSWER_EDIT_MODAL_SET,
  ANSWER_UPDATE,
  ANSWER_UPDATE_SUCCESS,
  ANSWER_UPDATE_ERROR,
  ANSWER_VIEW_TAB_SET,
  ANSWER_UPLOAD_SET,
  ANSWER_UPLOAD_SET_SUCCESS,
  ANSWER_UPLOAD_SET_ERROR,
  ANSWER_UPLOAD_RESET
} from '../../actions';

export const NAME = 'answer';

export const AnswerList = (page, num_page, orderBy, filters, stateFilter, display) => ({
  type: ANSWER_LIST,
  payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter, display: display }
});

export const AnswerListSuccess = (data) => ({
  type: ANSWER_LIST_SUCCESS,
  payload: data
});

export const AnswerListError = (error) => ({
  type: ANSWER_LIST_ERROR,
  payload: error
});

export const AnswerPageSet = (data) => ({
  type: ANSWER_PAGE_SET,
  payload: data
});

export const AnswerSearchSet = (data) => ({
  type: ANSWER_SEARCH_SET,
  payload: data
});

export const AnswerSearchChangeSet = (data) => ({
  type: ANSWER_SEARCH_CHANGE,
  payload: data
});

export const AnswerSearchAssessmentList = (data) => ({
  type: ANSWER_SEARCH_ASSESSMENT_LIST,
  payload: data
});

export const AnswerSearchAssessmentListSuccess = (message) => ({
  type: ANSWER_SEARCH_ASSESSMENT_LIST_SUCCESS,
  payload: message
});

export const AnswerSearchAssessmentListError = (error) => ({
  type: ANSWER_SEARCH_ASSESSMENT_LIST_ERROR,
  payload: error
}); 

export const AnswerAddChangeSet = (data) => ({
  type: ANSWER_ADD_CHANGE,
  payload: data
});

export const AnswerAddSet = (data) => ({
  type: ANSWER_ADD_SET,
  payload: data
});

export const AnswerAddModalSet = (data) => ({
  type: ANSWER_ADD_MODAL_SET,
  payload: data
});

export const AnswerAdd = (data) => ({
  type: ANSWER_ADD,
  payload: data
});

export const AnswerAddSuccess = (message) => ({
  type: ANSWER_ADD_SUCCESS,
  payload: message
});

export const AnswerAddError = (error) => ({
  type: ANSWER_ADD_ERROR,
  payload: error
});

export const AnswerDetail = (data) => ({
  type: ANSWER_DETAIL,
  payload: data
});

export const AnswerDetailSuccess = (data) => ({
  type: ANSWER_DETAIL_SUCCESS,
  payload: data
});

export const AnswerDetailError = (error) => ({
  type: ANSWER_DETAIL_ERROR,
  payload: error
});

export const AnswerViewModalSet = (data) => ({
  type: ANSWER_VIEW_MODAL_SET,
  payload: data
});

export const AnswerEditModalSet = (data) => ({
  type: ANSWER_EDIT_MODAL_SET,
  payload: data
});

export const AnswerEditChangeSet = (data) => ({
  type: ANSWER_EDIT_CHANGE,
  payload: data
});

export const AnswerUpdate = (data) => ({
  type: ANSWER_UPDATE,
  payload: data
});

export const AnswerUpdateSuccess = (message) => ({
  type: ANSWER_UPDATE_SUCCESS,
  payload: message.message
});

export const AnswerUpdateError = (error) => ({
  type: ANSWER_UPDATE_ERROR,
  payload: error
});

export const AnswerViewTabSet = (data) => ({
  type: ANSWER_VIEW_TAB_SET,
  payload: data
});

export const AnswerUploadSet = (file) => ({
  type: ANSWER_UPLOAD_SET,
  payload: { file },
});

export const AnswerUploadSetSuccess = (items) => ({
  type: ANSWER_UPLOAD_SET_SUCCESS,
  payload: items,
});

export const AnswerUploadSetError = (error) => ({
  type: ANSWER_UPLOAD_SET_ERROR,
  payload: error,
});

export const AnswerUploadReset= () => ({
  type: ANSWER_UPLOAD_RESET
});

const answer = (state) => state[NAME];

export const AnswerSelector = createStructuredSelector({
  answer
})
 